import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect } from "redux-saga/effects";
import environment from "@/settings/environment";

import api, { automaticApi } from "../../../settings/api";

export interface Fetch {
  name: string;
  email: string;
  message: string;
  userId?: string;
  callback: (success: boolean) => void;
}

export interface SendMessageAction {
  type: string;
  payload: Fetch;
}

export default function* sendMessage({
  payload,
}: SendMessageAction): Generator<
  CallEffect<unknown> | PutEffect<Action>,
  void,
  AxiosResponse
> {
  try {
    const body = {
      companyIdentification: environment.api.companyIdentification,
      customerIdentification: payload?.userId,
      email: payload.email,
      customerName: payload.name,
      message: payload.message,
      channel: environment.api.channel,
      contactType: "EMAIL",
    };

    const response = yield call(
      payload?.userId ? automaticApi.post : api.post,
      payload?.userId ? `/customer/v1/contact` : `/v1/customers/contact`,
      body,
    );

    if (
      response?.data?.data?.code === 0 ||
      response?.data?.status?.codigoRetorno
    ) {
      yield call(payload.callback, true);
    } else {
      yield call(payload.callback, false);
    }
  } catch (error) {
    yield call(payload.callback, false);
  }
}
